/**
 * ImagePreviewModal — full-screen image preview overlay
 */

import { X } from 'lucide-react';
import styles from '../AiConsultantPage.module.css';

interface ImagePreviewModalProps {
  url: string;
  onClose: () => void;
}

export function ImagePreviewModal({ url, onClose }: ImagePreviewModalProps) {
  return (
    <div
      className={styles.imagePreviewOverlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <button className={styles.imagePreviewClose} onClick={onClose} type="button">
        <X style={{ width: 20, height: 20 }} />
      </button>
      <img
        src={url}
        alt="preview"
        className={styles.imagePreviewImg}
        onError={() => onClose()}
      />
    </div>
  );
}
